/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AppControllerGetHelloQueryResponse } from "../../models/appController/AppControllerGetHello";

function getAppControllerGetHelloUrl() {
  const res = { method: 'GET', url: `/api/v1` as const }  
  return res
}

/**
 * {@link /api/v1}
 */
export async function appControllerGetHello(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<AppControllerGetHelloQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getAppControllerGetHelloUrl().url.toString(), ... requestConfig })  
  return res.data
}